import { get } from "../../utils/requests";
import Button from "../../buttons/Button";

/**
 * Tlacidlo pre generovanie API kluca
 * @param {*} value 
 * @param {*} onChange 
 * @param {*} obj 
 * @returns 
 */
export const GenerateButton = (value, onChange, obj) => {
  const handleClick = async () => {
    try {
      const res = await get("/api/meta/api-key");
      if (res?.Data) {
        await onChange("NApiKluc", res.Data);
      }
    } catch (error) {
      obj?.showMsg("Nepodarilo sa vygenerovať API kľúč")
    }
  }

  return (
    <Button
      onClick={handleClick}
      primary={true}
      disabled={!obj?.data?.LGen}
      label={"Generovať API kľúč"}
      type={"button"}
    />
  );
}